import React from 'react';
import { Link } from 'react-router-dom';
import FormattedQuestions from '../Items/FormattedQuestions';
import FormattedAnswer from '../Items/FormattedAnswer';
import { formatStructuredAnswer } from '../../utils/formatStructuredAnswer';
import LearningTags from './LearningTags';
import './learning-page-ui.css';
import './LearningFlashcard.css';

const GRADES = [
  { value: 'AGAIN', label: 'Again', hint: 'Forgot — review soon' },
  { value: 'HARD', label: 'Hard', hint: 'Struggled' },
  { value: 'GOOD', label: 'Good', hint: 'Got it' },
  { value: 'EASY', label: 'Easy', hint: 'Too easy' },
];

export default function LearningFlashcard({
  item,
  revealed,
  onReveal,
  onGrade,
  grading,
  sessionLabel,
  onSkip,
  showSaveActions,
  saved,
  onToggleSave,
}) {
  if (!item) {
    return null;
  }

  const questionText = item.question?.trim();
  if (!questionText) {
    return (
      <article className="learning-flashcard">
        <p className="learning-flashcard-meta">{sessionLabel || `Question #${item.id}`}</p>
        <p className="learning-flashcard-error">Could not load question text for this card.</p>
        <div className="learning-flashcard-actions">
          <Link to={`/question/${item.id}`} className="qd-btn qd-btn--secondary">
            Open full page
          </Link>
          {onSkip && (
            <button type="button" className="qd-btn qd-btn--ghost" onClick={onSkip}>
              Skip
            </button>
          )}
        </div>
      </article>
    );
  }

  const extraFormatted = item.extraInfo ? formatStructuredAnswer(item.extraInfo) : '';

  return (
    <article className="learning-flashcard">
      {sessionLabel && <p className="learning-flashcard-meta">{sessionLabel}</p>}
      <LearningTags item={item} />
      <h2 className="learning-flashcard-question">
        <FormattedQuestions item={item} />
      </h2>
      {!revealed ? (
        <div className="learning-flashcard-actions">
          <button type="button" className="qd-btn qd-btn--primary" onClick={onReveal}>
            Reveal answer
          </button>
          {onSkip && (
            <button type="button" className="qd-btn qd-btn--ghost" onClick={onSkip}>
              Skip
            </button>
          )}
          <Link to={`/question/${item.id}`} className="qd-btn qd-btn--secondary">
            Open full page
          </Link>
        </div>
      ) : (
        <>
          <div className="learning-flashcard-answer">
            <h3 className="learning-flashcard-answer-label">Answer</h3>
            <div className="learning-flashcard-answer-body">
              <FormattedAnswer item={item} />
            </div>
            {extraFormatted && (
              <>
                <h3 className="learning-flashcard-answer-label">Extra</h3>
                <pre className="learning-flashcard-extra">{extraFormatted}</pre>
              </>
            )}
          </div>
          <p className="learning-flashcard-grade-label">How well did you know this?</p>
          <div className="learning-flashcard-grades">
            {GRADES.map(({ value, label, hint }) => (
              <button
                key={value}
                type="button"
                className={`qd-btn learning-grade-chip ${value === 'GOOD' ? 'qd-btn--primary' : 'qd-btn--secondary'}`}
                disabled={Boolean(grading && grading !== value)}
                onClick={() => onGrade(value)}
              >
                <span className="learning-grade-btn">
                  <strong>{label}</strong>
                  <span>{hint}</span>
                </span>
              </button>
            ))}
          </div>
        </>
      )}
      {showSaveActions && onToggleSave && (
        <div className="learning-flashcard-actions learning-flashcard-actions--foot">
          <button type="button" className="qd-btn qd-btn--secondary" onClick={() => onToggleSave(item.id)}>
            {saved ? 'Remove from saved' : 'Save question'}
          </button>
        </div>
      )}
    </article>
  );
}
